module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade text-center",
    attrs: {
      "id": "pay-redirect",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [(_vm.currentPaymentMethod.id == 'airwallex') ? _c('modal-header') : [(!!_vm.errorMessage) ? _c('modal-header') : _vm._e()], _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.errorMessage === '') ? [_c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), (_vm.currentPaymentMethod.id == 'airwallex') ? _c('p', [_vm._v(_vm._s(_vm.$t('redirect')) + _vm._s(_vm.$t('airwallex')) + _vm._s(_vm.$t('wait')))]) : _c('p', [_vm._v(_vm._s(_vm.$t('redirect')) + _vm._s(_vm.$t(_vm.currentPaymentMethod.id)) + _vm._s(_vm.$t('wait')))])] : _vm._e(), _vm._v(" "), (_vm.errorMessage !== '') ? _c('p', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()], 2)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00266136!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/topup/payRedirect/PayRedirect.vue
// module id = 1249
// module chunks = 1